import * as types from './actionTypes/count-qd-enabled';

export interface CountingModel {
    count: number;
    isFetched: boolean;
}

export interface QDEnabledModel {
    isEnabled: boolean;
    isFetched: boolean;
}

export interface IRenewalDocumentCountActionType {
    type: typeof types.REQUIRED_DOCUMENTS_COUNT_FETCHED;
    payload: CountingModel;
}

export interface IQDExternalCommercialModelsCountActionType {
    type: typeof types.QD_EXTERNAL_COMMERCIAL_MODELS_COUNT_FETCHED;
    payload: CountingModel;
}

export interface IQDExternalConsumerModelsCountActionType {
    type: typeof types.QD_EXTERNAL_CONSUMER_MODELS_COUNT_FETCHED;
    payload: CountingModel;
}

export interface ICurrentApplicationsCountActionType {
    type: typeof types.CURRENT_APPLICATIONS_COUNT_FETCHED;
    payload: CountingModel;
}

export interface IQDEnabledActionType {
    type: typeof types.IS_QD_ENABLED;
    payload: QDEnabledModel;
}

export const renewalDocumentsCountFetched = (fetched: CountingModel) => ({ type: types.REQUIRED_DOCUMENTS_COUNT_FETCHED, payload: fetched, });
export const qdExternalCommercialModelsCountFetched = (fetched: CountingModel) => {
  return { type: types.QD_EXTERNAL_COMMERCIAL_MODELS_COUNT_FETCHED, payload: fetched, };
};
export const qdExternalConsumerModelsCountFetched = (fetched: CountingModel) => {
  return { type: types.QD_EXTERNAL_CONSUMER_MODELS_COUNT_FETCHED, payload: fetched, };
};

export const getCurrentApplicationsCountAction = (fetched: CountingModel) => {
  return { type: types.CURRENT_APPLICATIONS_COUNT_FETCHED, payload: fetched, };
};

export const isQDEnabledAction = (enabled: QDEnabledModel) => ({ type: types.IS_QD_ENABLED, payload: enabled, });
